import { SurveyQuestion } from '../../entities/survey_engine/SurveyQuestion';

export function getCpsQuestion(questions: SurveyQuestion[]) {
  return questions.find((question) => question.tag === 'cps');
}
